<template lang='pug'>
  div(
    @dragenter="dragEnter"
    @dragleave="dragLeave"
    @dragover.prevent
    @drop="drop"
    style="width:100%;height:100%"
  )
    slot
</template>

<script>
export default {
  name: 'UploadFile',
  data() {
    return {
      isDragging: false,
      dragCount: 0,
    };
  },

  methods: {
    dragEnter(e) {
      e.preventDefault();
      e.stopPropagation();
      this.dragCount += 1;
      this.$emit('dragging', true);
      this.isDragging = true;
    },
    dragLeave(e) {
      e.stopPropagation();
      e.preventDefault();
      this.dragCount -= 1;
      if (this.dragCount <= 0) {
        this.$emit('dragging', false);
        this.isDragging = false;
      }
    },
    drop(e) {
      this.dragCount = 0;
      e.preventDefault();
      e.stopPropagation();
      this.$emit('dragging', false);
      const { files } = e.dataTransfer;
      if (files) {
        this.$emit('drop-files', e);
      }
    },
  },
};
</script>
